import { render, staticRenderFns } from "./BottomAside.vue?vue&type=template&id=96369ac0&scoped=true&"
import script from "./BottomAside.vue?vue&type=script&lang=js&"
export * from "./BottomAside.vue?vue&type=script&lang=js&"
import style0 from "./BottomAside.vue?vue&type=style&index=0&id=96369ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96369ac0",
  null
  
)

export default component.exports